/**
 * xDrop API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional } from "@angular/core";
import { HttpClient, HttpHeaders, HttpParams, HttpResponse, HttpEvent, HttpParameterCodec, HttpContext } from "@angular/common/http";
import { CustomHttpParameterCodec } from "../encoder";
import { Observable } from "rxjs";

// @ts-ignore
import { PackerOrderPaginatedDto } from "../model/packerOrderPaginatedDto";

// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS } from "../variables";
import { Configuration } from "../configuration";

@Injectable({
  providedIn: "root",
})
export class PackersService {
  protected basePath = "http://localhost";
  public defaultHeaders = new HttpHeaders();
  public configuration = new Configuration();
  public encoder: HttpParameterCodec;

  constructor(
    protected httpClient: HttpClient,
    @Optional() @Inject(BASE_PATH) basePath: string | string[],
    @Optional() configuration: Configuration,
  ) {
    if (configuration) {
      this.configuration = configuration;
    }
    if (typeof this.configuration.basePath !== "string") {
      const firstBasePath = Array.isArray(basePath) ? basePath[0] : undefined;
      if (firstBasePath != undefined) {
        basePath = firstBasePath;
      }

      if (typeof basePath !== "string") {
        basePath = this.basePath;
      }
      this.configuration.basePath = basePath;
    }
    this.encoder = this.configuration.encoder || new CustomHttpParameterCodec();
  }

  // @ts-ignore
  private addToHttpParams(httpParams: HttpParams, value: any, key?: string): HttpParams {
    if (typeof value === "object" && value instanceof Date === false) {
      httpParams = this.addToHttpParamsRecursive(httpParams, value);
    } else {
      httpParams = this.addToHttpParamsRecursive(httpParams, value, key);
    }
    return httpParams;
  }

  private addToHttpParamsRecursive(httpParams: HttpParams, value?: any, key?: string): HttpParams {
    if (value == null) {
      return httpParams;
    }

    if (typeof value === "object") {
      if (Array.isArray(value)) {
        (value as any[]).forEach(elem => (httpParams = this.addToHttpParamsRecursive(httpParams, elem, key)));
      } else if (value instanceof Date) {
        if (key != null) {
          httpParams = httpParams.append(key, (value as Date).toISOString().substring(0, 10));
        } else {
          throw Error("key may not be null if value is Date");
        }
      } else {
        Object.keys(value).forEach(
          k => (httpParams = this.addToHttpParamsRecursive(httpParams, value[k], key != null ? `${key}.${k}` : k)),
        );
      }
    } else if (key != null) {
      httpParams = httpParams.append(key, value);
    } else {
      throw Error("key may not be null if value is not object or array");
    }
    return httpParams;
  }

  /**
   * Get orders for packers
   * @param page
   * @param limit
   * @param searchTerm
   * @param date String date eg: 2025-05-23
   * @param onlyFuture
   * @param orderBy
   * @param order
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public packerControllerGetOrdersForPackers(
    page: number,
    limit: number,
    searchTerm?: string,
    date?: string,
    onlyFuture?: boolean,
    orderBy?: string,
    order?: string,
    observe?: "body",
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: "application/json"; context?: HttpContext; transferCache?: boolean },
  ): Observable<PackerOrderPaginatedDto>;
  public packerControllerGetOrdersForPackers(
    page: number,
    limit: number,
    searchTerm?: string,
    date?: string,
    onlyFuture?: boolean,
    orderBy?: string,
    order?: string,
    observe?: "response",
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: "application/json"; context?: HttpContext; transferCache?: boolean },
  ): Observable<HttpResponse<PackerOrderPaginatedDto>>;
  public packerControllerGetOrdersForPackers(
    page: number,
    limit: number,
    searchTerm?: string,
    date?: string,
    onlyFuture?: boolean,
    orderBy?: string,
    order?: string,
    observe?: "events",
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: "application/json"; context?: HttpContext; transferCache?: boolean },
  ): Observable<HttpEvent<PackerOrderPaginatedDto>>;
  public packerControllerGetOrdersForPackers(
    page: number,
    limit: number,
    searchTerm?: string,
    date?: string,
    onlyFuture?: boolean,
    orderBy?: string,
    order?: string,
    observe: any = "body",
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: "application/json"; context?: HttpContext; transferCache?: boolean },
  ): Observable<any> {
    if (page === null || page === undefined) {
      throw new Error("Required parameter page was null or undefined when calling packerControllerGetOrdersForPackers.");
    }
    if (limit === null || limit === undefined) {
      throw new Error("Required parameter limit was null or undefined when calling packerControllerGetOrdersForPackers.");
    }

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (page !== undefined && page !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>page, "page");
    }
    if (limit !== undefined && limit !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>limit, "limit");
    }
    if (searchTerm !== undefined && searchTerm !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>searchTerm, "search_term");
    }
    if (date !== undefined && date !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>date, "date");
    }
    if (onlyFuture !== undefined && onlyFuture !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>onlyFuture, "only_future");
    }
    if (orderBy !== undefined && orderBy !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>orderBy, "order_by");
    }
    if (order !== undefined && order !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>order, "order");
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarCredential: string | undefined;
    // authentication (bearer) required
    localVarCredential = this.configuration.lookupCredential("bearer");
    if (localVarCredential) {
      localVarHeaders = localVarHeaders.set("Authorization", "Bearer " + localVarCredential);
    }

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ["application/json"];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set("Accept", localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: "text" | "json" | "blob" = "json";
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith("text")) {
        responseType_ = "text";
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = "json";
      } else {
        responseType_ = "blob";
      }
    }

    let localVarPath = `/packers/orders`;
    return this.httpClient.request<PackerOrderPaginatedDto>("get", `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      params: localVarQueryParameters,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      transferCache: localVarTransferCache,
      reportProgress: reportProgress,
    });
  }
}
